import type { BrandColor } from '@app-types/color'
import type { IconComponent } from '@components/icons/types'

/** `🔒` Icon */
export const Lock: IconComponent<Props> = ({
    color,
    width,
    height,
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 13 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <g opacity='.5'>
            <path
                d='M3.305 6.894V4.292C3.305 2.482 4.78 1 6.582 1 8.385 1 9.86 2.483 9.86 4.292v2.711'
                stroke={`var(--${color}`}
                strokeWidth='2'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.59 13.639a1.228 1.228 0 100-2.457 1.228 1.228 0 000 2.457z'
                fill={`var(--${color}`}
            />
            <path
                d='M6.59 15.187V12.52'
                stroke={`var(--${color}`}
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <rect
                x='1'
                y='8'
                width='11'
                height='11'
                rx='1'
                stroke={`var(--${color}`}
                strokeWidth='2'
            />
        </g>
    </svg>
)

interface Props {
    /** Color of the Lock */
    color?: BrandColor
}
